import { render, staticRenderFns } from "./diagnosisTags.vue?vue&type=template&id=1709ccf8&scoped=true"
import script from "./diagnosisTags.vue?vue&type=script&lang=js"
export * from "./diagnosisTags.vue?vue&type=script&lang=js"
import style0 from "./diagnosisTags.vue?vue&type=style&index=0&id=1709ccf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1709ccf8",
  null
  
)

export default component.exports